module.exports = __webpack_public_path__ + "static/media/table-cash.348caa0a.png";